// Static content data for Luxe Artificial Grass Ltd

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_haas-landscapes/artifacts/0u6x8p9a_LUXE%20AG%20LOGO.jpeg";

export const COMPANY = {
    name: "Luxe Artificial Grass Ltd",
    shortName: "Luxe Artificial Grass",
    tagline: "Coventry-based reliable landscapers",
    region: "Coventry & the West Midlands",
    companyNumber: "17240226",
    email: "luxeartificialgrass@gmail.com",
    phone: "07412324397",
    phoneTel: "+447412324397",
    whatsappNumber: "447412324397",
    barkUrl: "https://www.bark.com/en/gb/b/haas-construction-ltd/O4Evn/",
    tiktokUrl: "https://www.tiktok.com/@haas_construction_ltd?_r=1&_t=ZN-97LWyXhVeSM",
    instagramUrl: "https://www.instagram.com/haas_construction_ltd?igsh=MWdtNzgzbTFtaW03Nw%3D%3D&utm_source=qr",
};

export const NAV_LINKS = [
    { label: "Home", href: "#home", testid: "nav-link-home" },
    { label: "Offer", href: "#summer-offer", testid: "nav-link-offer" },
    { label: "Work", href: "#gallery", testid: "nav-link-gallery" },
    { label: "Services", href: "#services", testid: "nav-link-services" },
    { label: "Reviews", href: "#reviews", testid: "nav-link-reviews" },
    { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const SUMMER_OFFER = {
    badge: "SUMMER 2026",
    headline: "10% Off",
    subheadline: "Summer 2026 · all landscaping projects",
    note: "Limited spots — book your free site visit while dates last.",
    formHeadline: "Claim my 10% off",
    formNote: "Drop your name & number — we'll call you back within one working day with a free, no-obligation quote.",
};

export const GALLERY = [
    {
        id: 1,
        src: "https://customer-assets.emergentagent.com/job_haas-landscapes/artifacts/hhgt3g7e_IMG_5845.jpeg",
        title: "Artificial grass installation",
    },
    {
        id: 2,
        src: "https://customer-assets.emergentagent.com/job_haas-landscapes/artifacts/87oat5gg_IMG_5846.jpeg",
        title: "Artificial grass with fencing & porcelain patio",
    },
    {
        id: 3,
        src: "https://customer-assets.emergentagent.com/job_haas-landscapes/artifacts/nac8xt1o_IMG_5847.jpeg",
        title: "Front garden — grass with porcelain driveway",
    },
    {
        id: 4,
        src: "https://customer-assets.emergentagent.com/job_haas-landscapes/artifacts/0fo0qc8e_IMG_5848.jpeg",
        title: "Full rear-garden artificial grass install",
    },
];

export const WHATSAPP_PROMPT = {
    title: "Free landscape quote 🌿",
    message:
        "Message here via WhatsApp for your landscape quote — artificial grass, patios, driveways or fencing.",
    cta: "Chat on WhatsApp",
    prefill:
        "Hi Luxe Artificial Grass! I'd like a free quote for landscaping work — could you help?",
};

export const SERVICES = [
    {
        id: "grass",
        title: "Artificial Grass",
        emoji: "🌱",
        kicker: "Green all year round",
        description:
            "Premium artificial grass installs — front lawns, back gardens, roof terraces. Perfectly levelled base, weed membrane, kiln-dried sand and joint-free finish. Looks real, lasts years, needs zero mowing.",
        features: [
            "Premium 30–40mm grass ranges",
            "Weed-proof membrane & drainage",
            "Kiln-dried sand infill",
            "Neat edging & seamless joints",
            "Pet & child friendly",
        ],
        accent: "bg-haas-leaf/25",
    },
    {
        id: "patios",
        title: "Patios",
        emoji: "🧱",
        kicker: "Made for summer evenings",
        description:
            "Porcelain, sandstone and granite patios laid to last — proper sub-base, drainage falls and hand-pointed joints. We handle everything from tear-out to the final wash-down.",
        features: [
            "Porcelain tile patios",
            "Indian sandstone & granite",
            "Full sub-base + drainage",
            "Hand-pointed jointing",
            "Feature step-downs & edging",
        ],
        accent: "bg-haas-sun/40",
    },
    {
        id: "driveways",
        title: "Driveways",
        emoji: "🚗",
        kicker: "Kerb appeal, boosted",
        description:
            "Porcelain, block-paving and resin driveways designed to add real value. Structural sub-base, permeable drainage where needed and finishes built for winter, not just show.",
        features: [
            "Porcelain & block-paved drives",
            "Resin-bound options",
            "Permeable sub-base",
            "Full excavation & levelling",
            "Kerbs & drop-kerb work",
        ],
        accent: "bg-haas-coral/25",
    },
    {
        id: "fencing",
        title: "Fencing",
        emoji: "🪵",
        kicker: "Privacy done properly",
        description:
            "Venetian slats, close-board, feather-edge and lap panels — concrete-posted, gravel-boarded and lined up dead straight. Fencing built once, to stay standing for years.",
        features: [
            "Venetian slat panels",
            "Close-board & feather-edge",
            "Concrete posts + gravel boards",
            "Full removal of old fencing",
            "Gates and matching returns",
        ],
        accent: "bg-haas-navy/10",
    },
];

export const REVIEWS = [
    {
        id: 1,
        name: "James & Eleanor",
        location: "Coventry",
        rating: 5,
        text:
            "Luxe transformed our back garden with artificial grass and a new porcelain patio. Clean, on time, and the finish is outstanding. Neighbours keep asking who did it!",
    },
    {
        id: 2,
        name: "Priya S.",
        location: "Solihull",
        rating: 5,
        text:
            "Had venetian fence panels and grass installed — proper job. Friendly team, tidy site every day, and priced fairly. Really pleased.",
    },
    {
        id: 3,
        name: "Michael D.",
        location: "Warwick",
        rating: 5,
        text:
            "Full front driveway in porcelain plus fresh grass out back. Level, sharp edges and drainage all sorted. Five stars, easy.",
    },
    {
        id: 4,
        name: "Sarah & David",
        location: "Rugby",
        rating: 5,
        text:
            "We got three quotes for artificial grass — Luxe were the most straightforward and the only ones who did the prep properly. Six months in and it still looks brand new.",
    },
];

export const PROMISES = [
    { emoji: "💬", title: "Free, honest quotes", text: "We come out, take a look, and tell you the real cost. No fluff, no hidden bits." },
    { emoji: "🛠️", title: "One team, start to finish", text: "Same friendly faces from first chat to handover. No mystery subbies." },
    { emoji: "🧹", title: "Clean site, every day", text: "We treat your home like ours. Boots off where it matters, brushes out at the end." },
    { emoji: "📅", title: "We turn up when we say", text: "Diaries, not vibes. You'll always know when we're coming and what we're doing." },
];
